export class TaxTypeModel {
  taxTypeId: number = 0;
  countryId: number = 0;
  code: string = "";
  name: string = "";
  jurisdictionId: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
